import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link, Navigate } from 'react-router-dom';
import { Menu } from 'antd';
import PdfExportsDashboard from './pdf-exports/PdfExportsDashboard';
import ProductReportPage from './product-report/ProductReportPage';
import TeamInsightsDashboard from './team-insights/TeamInsightsDashboard';
import MonthlyReportsDashboard from './team-insights/reports/MonthlyReportsDashboard';
import MonthlyReportEditor from './team-insights/reports/MonthlyReportEditor';
import MemberEventsDashboard from './team-insights/events/MemberEventsDashboard';
import './App.css';

function App() {
    return (
        <Router>
            <div>
                <Menu
                    mode="horizontal"
                    theme="dark"
                    selectable={false}
                    items={[
                        {
                            key: 'pdf-exports',
                            label: <Link to="/pdf-exports">PDF Exports</Link>,
                        },
                        {
                            key: 'product-report',
                            label: <Link to="/product-report">Product Report</Link>,
                        },
                        {
                            key: 'team-insights',
                            label: 'Team Insights',
                            children: [
                                {
                                    key: 'team-insights-dashboard',
                                    label: <Link to="/team-insights">Dashboard</Link>,
                                },
                                {
                                    key: 'monthly-reports',
                                    label: <Link to="/team-insights/reports">Monthly Reports</Link>,
                                },
                                {
                                    key: 'member-events',
                                    label: <Link to="/team-insights/events">Member Events</Link>,
                                },
                            ],
                        },
                    ]}
                />

                <div className="content">
                    <Routes>
                        <Route path="/pdf-exports" element={<PdfExportsDashboard />} />
                        <Route path="/product-report" element={<ProductReportPage />} />
                        <Route path="/team-insights" element={<TeamInsightsDashboard />} />
                        <Route path="/team-insights/reports" element={<MonthlyReportsDashboard />} />
                        <Route path="/team-insights/reports/:login" element={<MonthlyReportEditor />} />
                        <Route path="/team-insights/events" element={<MemberEventsDashboard />} />
                        <Route path="/" element={<Navigate to="/pdf-exports" replace />} />
                    </Routes>
                </div>
            </div>
        </Router>
    );
}

export default App;
